interface IComputeNewOffsetParams {
  overflowContainerNode: HTMLElement;
  slideNode: HTMLElement;
  additionalOffset: number;
}

export function computeNewOffset(params: IComputeNewOffsetParams): number {
  const { overflowContainerNode, slideNode, additionalOffset } = params;

  const overflowContainerNodeRect = overflowContainerNode.getBoundingClientRect();
  const slideNodeRect = slideNode.getBoundingClientRect();

  return overflowContainerNodeRect.left - slideNodeRect.left + additionalOffset;
}
